/**
 * @generated SignedSource<<01fff5d909d9727b0f0c9254bdc28a18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserProfileDetailConnectUpdateInput = {
  roleId?: string | null;
  type?: string | null;
  profileInformation?: any | null;
  onboardingTourCompletion?: any | null;
  pricing?: any | null;
  profileSettings?: any | null;
  defaultSessionPassword?: string | null;
  zoomDetails?: any | null;
  zoomCredentials?: any | null;
  clientLocations?: any | null;
  preferredVideoType?: string | null;
  googleCalendarSync?: boolean | null;
  signedAgreement?: any | null;
  setupCompletedAt?: any | null;
  onboardingStatus?: string | null;
  onboardingApprovedAt?: any | null;
  applicationStatus?: string | null;
  applicationApprovedAt?: any | null;
  documentStatus?: string | null;
  profileStatus?: string | null;
  specialityIds?: ReadonlyArray<string> | null;
  profileQuestionResponses?: ReadonlyArray<UserProfileQuestionUpdateInput> | null;
};
export type UserProfileQuestionUpdateInput = {
  userId?: string | null;
  answer?: string | null;
  profileQuestionId?: string | null;
};
export type userUpdateUserProfileDetailConnectMutation$variables = {
  id: string;
  input: UserProfileDetailConnectUpdateInput;
};
export type userUpdateUserProfileDetailConnectMutation$data = {
  readonly updateUserProfileDetailConnectWithSetupCompleteCheck: {
    readonly userProfileDetailConnect: {
      readonly " $fragmentSpreads": FragmentRefs<"userProfileDetailFragment">;
    };
  };
};
export type userUpdateUserProfileDetailConnectMutation = {
  variables: userUpdateUserProfileDetailConnectMutation$variables;
  response: userUpdateUserProfileDetailConnectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userUpdateUserProfileDetailConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserProfileDetailConnectPayload",
        "kind": "LinkedField",
        "name": "updateUserProfileDetailConnectWithSetupCompleteCheck",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileDetailConnect",
            "kind": "LinkedField",
            "name": "userProfileDetailConnect",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileDetailFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userUpdateUserProfileDetailConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserProfileDetailConnectPayload",
        "kind": "LinkedField",
        "name": "updateUserProfileDetailConnectWithSetupCompleteCheck",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileDetailConnect",
            "kind": "LinkedField",
            "name": "userProfileDetailConnect",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileSettings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultSessionPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoomDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientLocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredVideoType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleCalendarSync",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAgreement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setupCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategorisedSpecialities",
                "kind": "LinkedField",
                "name": "specialities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "approaches",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "areasOfExpertise",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "trackingOnlySpecialities",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "clientGroups",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileQuestion",
                "kind": "LinkedField",
                "name": "profileQuestionResponses",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileQuestion",
                    "kind": "LinkedField",
                    "name": "profileQuestion",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "translationKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingApprovedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationApprovedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fd930a71c443b629ef640455ddbd7c7d",
    "id": null,
    "metadata": {},
    "name": "userUpdateUserProfileDetailConnectMutation",
    "operationKind": "mutation",
    "text": "mutation userUpdateUserProfileDetailConnectMutation(\n  $id: ID!\n  $input: UserProfileDetailConnectUpdateInput!\n) {\n  updateUserProfileDetailConnectWithSetupCompleteCheck(id: $id, input: $input) {\n    userProfileDetailConnect {\n      ...userProfileDetailFragment\n      id\n    }\n  }\n}\n\nfragment userProfileApplicationStatusFragment on UserProfileDetailConnect {\n  onboardingStatus\n  applicationStatus\n  documentStatus\n  profileStatus\n  setupCompletedAt\n  onboardingApprovedAt\n  applicationApprovedAt\n}\n\nfragment userProfileDetailFragment on UserProfileDetailConnect {\n  id\n  type\n  roleId\n  profileInformation\n  profileSettings\n  defaultSessionPassword\n  zoomDetails\n  clientLocations\n  preferredVideoType\n  googleCalendarSync\n  signedAgreement\n  setupCompletedAt\n  specialities {\n    approaches {\n      id\n      name\n    }\n    areasOfExpertise {\n      id\n      name\n    }\n    trackingOnlySpecialities {\n      id\n      name\n    }\n    clientGroups {\n      id\n      name\n    }\n  }\n  profileQuestionResponses {\n    id\n    answer\n    profileQuestion {\n      id\n      translationKey\n      question\n    }\n  }\n  ...userProfileApplicationStatusFragment\n}\n"
  }
};
})();

(node as any).hash = "988448211702f1dee30898949048eedb";

export default node;
